import React from "react";

import CmsPreviewShell from "./CmsPreviewShell";

import type { CmsComponentProps, FeaturedMock } from "./types";

const formatPrice = (price: number) => price.toLocaleString("ko-KR") + "원";

const FeaturedComponent: React.FC<CmsComponentProps> = ({ title, layout, items: userItems }) => {
  const items: FeaturedMock[] =
    userItems && userItems.length > 0
      ? userItems
          .filter((i) => i.is_active !== false)
          .map((i, idx) => ({
            id: idx,
            title: i.title,
            description: i.description ?? "",
            img: i.img ?? "",
            price: i.price ?? 0,
            originPrice: i.origin_price,
            discount: i.discount,
            type: i.type ?? "product",
          }))
      : [];

  return (
    <CmsPreviewShell title={title}>
      <div className={`cms-featured cms-featured--${layout}`}>
        {items.map((item) => (
          <div key={item.id} className="cms-featured__item">
            <div className="cms-featured__image">
              {item.img ? <img src={item.img} alt={item.title} /> : <div className="cms-featured__placeholder">이미지 없음</div>}
              <span className={`cms-featured__badge cms-featured__badge--${item.type}`}>{item.type === "lesson" ? "강습" : "상품"}</span>
            </div>
            <div className="cms-featured__body">
              <h5 className="cms-featured__name">{item.title}</h5>
              {item.description && <p className="cms-featured__desc">{item.description}</p>}
              <div className="cms-featured__price">
                {item.discount ? (
                  <>
                    <span className="cms-featured__discount">{item.discount}%</span>
                    <span className="cms-featured__final">{formatPrice(item.price)}</span>
                  </>
                ) : (
                  <span className="cms-featured__final">{formatPrice(item.price)}</span>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </CmsPreviewShell>
  );
};

export default FeaturedComponent;
